import { Column, TableConfig } from "components/display/Table/types";

interface TableSkeletonProps<T extends Record<string, any>> {
  columns: Column<T>[];
  selectable: boolean;
  actions?: boolean;
  styling?: TableConfig<T>['styling'];
  rowCount?: number;
}

const SkeletonRow = <T extends Record<string, any>>({
  columns,
  selectable,
  actions,
  styling,
  index
}: {
  columns: Column<T>[];
  selectable: boolean;
  actions?: boolean;
  styling?: TableConfig<T>['styling'];
  index: number;
}) => (
  <tr
    className={`${styling?.rowClass || ''} ${index % 2 === 0 ? styling?.evenRowClass || '' : ''
      } animate-pulse`}
  >
    {selectable && (
      <td className="px-6 py-4">
        <div className="w-4 h-4 bg-gray-200 rounded"></div>
      </td>
    )}
    {columns.map((column, colIndex) => (
      <td
        key={colIndex}
        className={`px-6 py-4 text-sm whitespace-nowrap text-${column.align || 'left'
          } ${column.className || ''}`}
      >
        <div
          className={`bg-gray-200 rounded h-4 ${colIndex % 3 === 0
              ? 'w-24'
              : colIndex % 3 === 1
                ? 'w-32'
                : 'w-20'
            }`}
        ></div>
      </td>
    ))}
    {actions && (
      <td className="px-6 py-4 whitespace-nowrap">
        <div className="flex space-x-2">
          <div className="w-8 h-6 bg-gray-200 rounded"></div>
          <div className="w-8 h-6 bg-gray-200 rounded"></div>
        </div>
      </td>
    )}
  </tr>
);

const SkeletonTable = <T extends Record<string, any>>({
  columns,
  selectable,
  actions,
  styling,
  rowCount = 5
}: TableSkeletonProps<T>) => {
  return (
    <tbody className="bg-white divide-y divide-gray-200">
      {Array.from({ length: rowCount }, (_, index) => (
        <SkeletonRow
          key={index}
          columns={columns}
          selectable={selectable}
          actions={actions}
          styling={styling}
          index={index}
        />
      ))}
    </tbody>
  );
};

export default SkeletonTable;
